module.exports = __webpack_public_path__ + "static/img/my2.7492d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my2.png
// module id = 1/Uj
// module chunks = 1